import { p as proxyCustomElement, H, c as createEvent, h } from './p-ae815584.js';
import { b as bem, g as global$1, i as isNodeEnvironment } from './p-c44c2366.js';
import { t as tippy } from './p-5b08239b.js';
import { u as useKeyboard } from './p-5e5972c7.js';
import { r as resolveAppearance } from './p-c01ca34a.js';

const cosmosActionMenuCss = ":host{display:inline-block;height:0;width:0}.cosmos-action-menu{pointer-events:none;position:relative;visibility:hidden;z-index:1}.cosmos-action-menu--open{pointer-events:auto;visibility:visible}.cosmos-action-menu__menu-container{background-color:var(--cosmos-action-menu-background-color, #FFFFFF);border:1px solid rgba(0, 15, 30, 0.2);border-radius:var(--cosmos-action-menu-border-radius, 4px);-webkit-box-shadow:0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431);box-shadow:0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431);-webkit-box-sizing:border-box;box-sizing:border-box;max-height:var(--cosmos-action-menu-max-height);min-width:148px;overflow:auto;position:absolute;right:0;top:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:var(--cosmos-action-menu-width)}.cosmos-action-menu__menu-container ::slotted(cosmos-action-menu-group:last-of-type){--cosmos-action-menu-group-padding-bottom:4px}.cosmos-action-menu__menu-container--appearance-light ::slotted(cosmos-action-menu-group:nth-of-type(n+2)){border-top:1px solid rgba(0, 15, 30, 0.1);padding-top:4px}.cosmos-action-menu__menu-container--appearance-dark{background-color:#00162B;border:1px solid rgba(255, 255, 255, 0.45)}.cosmos-action-menu__menu-container--appearance-dark ::slotted(cosmos-action-menu-group:nth-of-type(n+2)){border-top:1px solid rgba(255, 255, 255, 0.2);padding-top:4px}.cosmos-action-menu__menu-container--appearance-dark .cosmos-action-menu__header ::slotted([slot=header]){background-color:#00162B}.cosmos-action-menu__menu{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;left:0;overflow:auto;padding:var(--cosmos-action-menu-padding, 4px)}.cosmos-action-menu__header{display:-ms-flexbox;display:flex}.cosmos-action-menu__header ::slotted([slot=header]){background-color:#F8F8F8;padding:12px;width:100%}";
const CosmosActionMenuStyle0 = cosmosActionMenuCss;

const CosmosActionMenu$1 = /*@__PURE__*/ proxyCustomElement(class CosmosActionMenu extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.hide = createEvent(this, "hide", 7);
        this.show = createEvent(this, "show", 7);
        this.generateClassNames = bem('cosmos-action-menu');
        this.actionItems = [];
        this.PLACEMENTS = {
            above: {
                start: ['top-start', 'top', 'top-end'],
                center: ['top', 'top-end', 'bottom', 'bottom-end'],
                end: ['top-end', 'top', 'top-start'],
            },
            below: {
                start: ['bottom-start', 'bottom', 'bottom-end'],
                center: ['bottom', 'bottom-end', 'top', 'top-end'],
                end: ['bottom-end', 'bottom', 'bottom-start'],
            },
        };
        this.FALLBACK_PLACEMENTS = {
            above: {
                start: ['top', 'bottom-start', 'bottom', 'bottom-end'],
                center: ['top-start', 'top-end', 'bottom', 'bottom-end'],
                end: ['top', 'top-start', 'bottom-end', 'bottom', 'bottom-start'],
            },
            below: {
                start: ['bottom', 'bottom-start', 'top-start', 'top'],
                center: ['bottom-start', 'bottom-end', 'top', 'top-end'],
                end: ['bottom', 'bottom-start', 'top-end', 'top', 'top-start'],
            },
        };
        this.handleOutsideClick = (event) => {
            if (!this.isMenuVisible) {
                return;
            }
            if (this.container && !this.container.contains(event.target)) {
                this.closeMenu();
            }
        };
        this.closeMenu = () => {
            var _a;
            this.isMenuVisible = false;
            (_a = this.tippyInstance) === null || _a === void 0 ? void 0 : _a.hide();
            this.hide.emit();
        };
        this.handleMenuClick = (event) => {
            // if target is a menu item, allow the click event to propagate
            if (event.target.closest('cosmos-action-menu-item')) {
                return;
            }
            else {
                event.stopPropagation();
            }
        };
        this.align = 'start';
        this.anchor = undefined;
        this.appearance = undefined;
        this.open = false;
        this.placement = 'below';
        this.trigger = undefined;
        this.computedAppearance = 'light';
        this.isMenuVisible = this.open;
    }
    handleAppearanceChange(appearance) {
        if (appearance === this.computedAppearance) {
            return;
        }
        this.computedAppearance = appearance;
    }
    getAnchorElement() {
        return global$1.document.getElementById(this.anchor);
    }
    getTriggerElement() {
        return global$1.document.getElementById(this.trigger);
    }
    initActions() {
        const actionItems = Array.from(this.element.querySelectorAll('cosmos-action-menu-item'));
        this.actionItems = actionItems.map((item) => {
            return {
                index: actionItems.indexOf(item),
                ref: item,
            };
        });
    }
    useAnchorOrTrigger() {
        const anchorElement = this.getAnchorElement();
        const triggerElement = this.getTriggerElement();
        // if both a trigger and an anchor are provided, use the anchor
        if (anchorElement && triggerElement) {
            return anchorElement;
        }
        else if (anchorElement && !triggerElement) {
            // if only an anchor is provided, use the anchor
            return anchorElement;
        }
        else if (!anchorElement && triggerElement) {
            // if only a trigger is provided, use the trigger
            // this is the default behavior
            return triggerElement;
        }
        return null;
    }
    computePlacement() {
        const placement = this.PLACEMENTS[this.placement][this.align][0];
        const fallBackPlacement = this.FALLBACK_PLACEMENTS[this.placement][this.align];
        return {
            placement,
            fallBackPlacement,
        };
    }
    initTippy() {
        if (isNodeEnvironment()) {
            return;
        }
        const menuContainer = this.menuContainer;
        const tippyElement = this.useAnchorOrTrigger();
        if (!tippyElement || !menuContainer) {
            return;
        }
        const { placement, fallBackPlacement } = this.computePlacement();
        this.tippyInstance = tippy(tippyElement, {
            appendTo: this.container,
            trigger: 'manual', // The kind of event that triggers the tooltip e.g. 'click', 'mouseenter'. We do this manually.
            offset: [0, 8],
            placement,
            interactive: true,
            hideOnClick: false,
            allowHTML: true,
            aria: {
                content: null,
                expanded: false,
            },
            popperOptions: {
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: fallBackPlacement,
                            boundary: 'viewport',
                        },
                    },
                ],
            },
            onCreate() {
                tippyElement.setAttribute('aria-haspopup', 'true');
            },
            onShow: () => {
                this.show.emit();
                this.isMenuVisible = true;
                tippyElement.setAttribute('aria-expanded', 'true');
            },
            onHide: () => {
                this.hide.emit();
                this.isMenuVisible = false;
                tippyElement.setAttribute('aria-expanded', 'false');
            },
            render() {
                return {
                    popper: menuContainer,
                };
            },
        });
        if (this.open) {
            this.tippyInstance.show();
        }
    }
    initKeyboard() {
        const trigger = this.getTriggerElement();
        const menu = this.menuContainer;
        const tippyInstance = this.tippyInstance;
        const actionItems = this.actionItems;
        if (!trigger || !menu || !tippyInstance || actionItems.length === 0) {
            return;
        }
        const keyboard = useKeyboard({ trigger, menu, tippyInstance }, this.actionItems);
        this.cleanupKeyboard = keyboard.cleanup;
        keyboard.setup();
    }
    setTriggerAccessibilityAttributes() {
        const trigger = this.getTriggerElement();
        if (!trigger) {
            return;
        }
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', this.isMenuVisible ? 'true' : 'false');
        trigger.setAttribute('aria-controls', 'cosmos-action-menu');
    }
    componentDidLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'dark', light: 'light' },
            callback: this.handleAppearanceChange.bind(this),
        });
        this.initActions();
        this.initTippy();
        this.initKeyboard();
        this.setTriggerAccessibilityAttributes();
        global$1.window.addEventListener('click', this.handleOutsideClick);
    }
    disconnectedCallback() {
        var _a;
        global$1.window.removeEventListener('click', this.handleOutsideClick);
        if (this.cleanupKeyboard) {
            this.cleanupKeyboard();
        }
        (_a = this.tippyInstance) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    render() {
        return (h("div", { key: '51c1baa07f2c194acf1c3ff9b1862cb7b105ff40', class: this.generateClassNames({
                appearance: this.computedAppearance,
                open: this.isMenuVisible,
            }), id: "cosmos-action-menu", ref: (el) => (this.container = el), onClick: this.handleMenuClick, role: "menu", tabIndex: -1, "aria-labelledby": this.trigger, part: "base" }, h("div", { key: '22a18735388b65ed8ab532504e87f8dc10c90bbe', class: this.generateClassNames('menu-container', {
                appearance: this.computedAppearance,
            }), ref: (el) => (this.menuContainer = el) }, h("div", { key: '0b9fdda0b09d7dbc01220483bccea93254f9ea8b', class: this.generateClassNames('header') }, h("slot", { key: '84d2fbaf42486de7f0ede2391cb9e633ae8dc3ad', name: "header" })), h("div", { key: '242b5f8c18a4ee87d2c7bf8dfbd2d7aefbcc41de', class: this.generateClassNames('menu'), tabIndex: -1, part: "menu" }, h("slot", { key: '37c52ee7d43ab16c453636ee188cdfdb25140b2f' })))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"]
    }; }
    static get style() { return CosmosActionMenuStyle0; }
}, [1, "cosmos-action-menu", {
        "align": [513],
        "anchor": [513],
        "appearance": [513],
        "open": [516],
        "placement": [513],
        "trigger": [513],
        "computedAppearance": [32],
        "isMenuVisible": [32]
    }, undefined, {
        "appearance": ["handleAppearanceChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-action-menu"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-action-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosActionMenu$1);
            }
            break;
    } });
}

const CosmosActionMenu = CosmosActionMenu$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosActionMenu, defineCustomElement };
